const PREFIX = "USER"
const USER_TYPES = {
  UPDATE_USER: `${PREFIX}/UPDATE`,
  CREATE_USER: `${PREFIX}/CRATE`,
  LOAD_USER: `${PREFIX}/LOAD`,
  CLEAR: `${PREFIX}/CLEAR`
}

export default USER_TYPES
